import { type IntlShape } from 'react-intl'

export const shippingAccessorGetFormattedShippingTypeLabel = ({
  intl,
  shippingTypeCode,
}: {
  intl: IntlShape
  shippingTypeCode: string
}): string => {
  switch (shippingTypeCode) {
    case 'express': {
      return intl.formatMessage({
        id: 'carrier.type.express',
      })
    }
    case 'sameday': {
      return intl.formatMessage({
        id: 'carrier.type.sameday',
      })
    }
    case 'standard': {
      return intl.formatMessage({
        id: 'carrier.type.standard',
      })
    }
    default: {
      return intl.formatMessage({
        id: 'carrier.type.spedition',
      })
    }
  }
}
